import React, { useState } from "react";

const ScheduledCleaningOffcanvas = () => {
  const [mode, setMode] = useState("date"); // 'date' or 'days'
  const [scheduleDate, setScheduleDate] = useState("");
  const [days, setDays] = useState("");
  const [isRecurring, setIsRecurring] = useState(false);
// filterId, show, onClose, onSave
//   const handleSubmit = () => {
//     const data = {
//     //   filter_id: filterId,
//       type: mode,
//       value: mode === "date" ? scheduleDate : days,
//       recurring: mode === "days" ? isRecurring : false,
//     };
//     console.log("Scheduled Cleaning Data:", data);
//     onSave && onSave(data); // Optional external handler
//     onClose();
//   };

  return (
    <div> <style>
        {`
        @media (max-width: 576px) {
          #offcanvasScheduleCleaning {
            width: 90% !important;
          }
        }

        @media (min-width: 577px) and (max-width: 992px) {
          #offcanvasScheduleCleaning {
            width: 55% !important;
          }
        }

        @media (min-width: 993px) and (max-width: 1440px) {
          #offcanvasScheduleCleaning {
            width:25% !important;
          }
        }
          
        @media (min-width: 1441px)  {
          #offcanvasScheduleCleaning {
            width: 17% !important;
          }
        }
        `}
      </style>
    <div
      className={`offcanvas offcanvas-end`}
      tabIndex="-1"
    id="offcanvasScheduleCleaning"
        aria-labelledby="offcanvasScheduleCleaning"
    >
      <div className="offcanvas-header">
        <h5 className="offcanvas-title">Scheduled Cleaning</h5>
        <div className="d-flex align-items-center ms-auto">
            <button
              type="submit"
              className="btn btn-sm btn-outline-success me-2"
              title="Schedule"
               data-bs-dismiss="offcanvas"
            >
              <i className="fa fa-check fs-4"></i>
            </button>

            <button
              type="button"
              className="btn-close text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
      </div>
      <div className="offcanvas-body">
        {/* <p><strong>Filter ID:</strong> {filterId}</p> */}

        <div className="mb-3">
          <label className="form-label">Select Mode:</label><br />
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="scheduleMode"
              value="date"
              checked={mode === "date"}
              onChange={() => setMode("date")}
            />
            <label className="form-check-label">Pick Date</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="scheduleMode"
              value="days"
              checked={mode === "days"}
              onChange={() => setMode("days")}
            />
            <label className="form-check-label">Enter Days</label>
          </div>
        </div>

        {mode === "date" && (
          <div className="mb-3">
            <label className="form-label">Next Scheduled Date</label>
            <input
              type="date"
              className="form-control"
              value={scheduleDate}
              onChange={(e) => setScheduleDate(e.target.value)}
            />
          </div>
        )}

        {mode === "days" && (
          <>
            <div className="mb-3">
              <label className="form-label">Enter Number of Days</label>
              <input
                type="number"
                className="form-control"
                min="1"
                value={days}
                 onWheel={(e) => e.target.blur()}
                onChange={(e) => setDays(e.target.value)}
              />
            </div>
            <div className="form-check mb-3">
              <input
                className="form-check-input"
                type="checkbox"
                id="recurringCheck"
                checked={isRecurring}
                onChange={() => setIsRecurring(!isRecurring)}
              />
              <label className="form-check-label" htmlFor="recurringCheck">
                Make it recurring
              </label>
            </div>
          </>
        )}

        {/* <button className="btn btn-primary w-100" onClick={handleSubmit}>
          <i className="fa fa-save me-2"></i>Schedule
        </button> */}
      </div>
    </div></div>
  );
};

export default ScheduledCleaningOffcanvas;
